import { SocialFormFields } from '@app/pre-build/src/components/OnboardingFlows/Flowtag/OnboardingForms/SocialForm/SocialForm.types'
import { SocialFormInputType } from '@app/pre-build/src/components/OnboardingFlows/Flowtag/OnboardingForms/SocialForm/SocialForm.constants'

export const COMBINED_FUNNEL_FORM_INPUT_ENTRIES = Object.entries({
  [SocialFormFields.LINK]: {
    label: 'Website',
    prefix: '',
    startAdornment: undefined,
    inputAdornmentText: '',
    placeholder: 'www.website.com',
    widgetType: 'socialLink'
  },
  [SocialFormFields.INSTAGRAM]: {
    label: 'Instagram',
    prefix: 'https://www.instagram.com/',
    startAdornment: undefined,
    inputAdornmentText: '@',
    placeholder: 'yourname',
    widgetType: 'socialLink'
  },
  [SocialFormFields.SMS]: {
    label: 'SMS',
    prefix: '',
    startAdornment: undefined,
    inputAdornmentText: '',
    placeholder: '555-555-5555',
    type: 'tel',
    widgetType: 'contactInfo'
  }
  // [SocialFormFields.BIGIMAGE]: {
  //   label: 'Image',
  //   prefix: '',
  //   startAdornment: undefined,
  //   inputAdornmentText: '',
  //   placeholder: 'file size limit: 10mb',
  //   type: 'file',
  //   widgetType: 'bigImage'
  // },
  // [SocialFormFields.PDF]: {
  //   label: 'File',
  //   prefix: '',
  //   startAdornment: undefined,
  //   inputAdornmentText: '',
  //   placeholder: 'Upload PDF',
  //   type: 'file',
  //   widgetType: 'pdf'
  // }
}) as [SocialFormFields, SocialFormInputType][]

export const FILE_TYPE_FIELDS = [SocialFormFields.BIGIMAGE, SocialFormFields.PDF]
